<template>
	<div class="assessment-detail">
    <elsa-tree
      accordion
      icon-class="tree-icon"
      default-expand-all
      :data="treeData"
    >
      <template v-slot:title="{ node }">
        <span v-bind:class="node.data.options.titleClassArray">
          {{ node.data.label }}
        </span>
      </template>
    </elsa-tree>
	</div>
</template>

<script>
import ElsaTree from "@/components/common/Tree";
import { mapState } from "vuex";

const DEFAULT_CHILD_OPTIONS = {
	showIcon: true,
	iconClassArray: ["elsa-level-down", "elsa-game-type-assessment"],
	assignAction: false,
}

export default {
  components: {
    ElsaTree,
  },
  props: {
    assessments: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState("assignments", ["assessmentList"]),
    firstAssignedAssessment() {
      return this.assessments[0]
    },
    treeData() {
      return this.assessmentList.map((item) => {
        return {
          ...item,
          children: [
						{
							...item.children.find(child => {
								return this.firstAssignedAssessment && child.id === this.firstAssignedAssessment.id
							}),
							options: DEFAULT_CHILD_OPTIONS
						}
					]
        }
      })
    }
  }
};
</script>

<style lang="scss" >
.assessment-detail {
  margin-bottom: 40px;
}
::v-deep {
  .section-header {
    padding-left: 0
  }
}
.assessment-level-1-title {
    line-height: 24px;
    font-size: 20px;
    letter-spacing: .25px;
  }
</style>
